import { render, staticRenderFns } from "./SelectById.vue?vue&type=template&id=70ee8b07&scoped=true&lang=pug"
import script from "./SelectById.vue?vue&type=script&lang=js"
export * from "./SelectById.vue?vue&type=script&lang=js"
import style0 from "./SelectById.vue?vue&type=style&index=0&id=70ee8b07&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ee8b07",
  null
  
)

export default component.exports